module.exports = __webpack_public_path__ + "img/nav2.06571a47.png";